window._support = window._support || { 'ui': {}, 'user': {} };
window._support['account'] = 'menvaraosat';
window._support['ui']['contactMode'] = 'mixed';
window._support['ui']['enableKb'] = 'true';
window._support['ui']['styles'] = {
  widgetColor: 'rgba(16, 162, 197, 1)',
  gradient: true,
};
window._support['ui']['shoutboxFacesMode'] = 'default';
window._support['ui']['shoutboxHeaderLogo'] = true;
window._support['ui']['widget'] = {
  displayOn: 'all',
  fontSize: 'default',
  allowBotProcessing: true,
  slug: 'men-varaosat-oy-chat-slash-contact-form-shoutbox',
  label: {
    text: 'Let us know if you have any questions! &#128522;',
    mode: "notification",
    delay: 3,
    duration: 30,
    primary: 'I have a question',
    secondary: 'No, thanks',
    sound: true,
  },
  position: 'bottom-right',
  mobilePosition: 'bottom-right'
};
window._support['apps'] = {
  faq: {"enabled":true},
  recentConversations: {},
  orders: {},
  shopper: {}
};
window._support['ui']['appOrder'] = ["faq","orders","shopper","recentConversations"];

const initReamaze = () => {
  if (window.reamazeInitialized) return;
  window.reamazeInitialized = true;
  
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://cdn.reamaze.com/assets/reamaze-loader.js';
  document.body.appendChild(script);

  const events = ['mousemove', 'touchstart', 'scroll', 'click'];
  for (const event of events) {
    window.removeEventListener(event, initReamaze);
  }
};

const reamazeEvents = ['mousemove', 'touchstart', 'scroll', 'click'];
for (const event of reamazeEvents) {
  window.addEventListener(event, initReamaze, { passive: true, once: true });
}

setTimeout(initReamaze, 7000);
